import { render, staticRenderFns } from "./notes-renderer.vue?vue&type=template&id=36963c6a&scoped=true"
import script from "./notes-renderer.vue?vue&type=script&lang=js"
export * from "./notes-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36963c6a",
  null
  
)

export default component.exports